module.exports = __webpack_public_path__ + "static/media/whale.3ac32431.png";